/**
 * Sort the events list based on event date.
 */
export var sortEventList = function (eventList) {
    var sortedEvents = eventList.sort(function (a, b) {
        return a.date.getTime() - b.date.getTime();
    });
    return sortedEvents;
};
